export type SaveOutcome<T> =
	| { ok: true; value: T; latest: boolean }
	| { ok: false; error: unknown; latest: boolean };

/**
 * 同じキーの保存を頼んだ順に 1 件ずつ送る。全項目を置き換える PUT を並行に送ると、
 * 届いた順によって古い値がサーバーにも画面にも後勝ちで残るため。
 * latest は、結果が出た時点でこの保存の後に同じキーの保存が頼まれていないか。画面に反映するのは latest だけにする。
 */
export class SerialSaves {
	private readonly tails = new Map<string, Promise<unknown>>();
	private readonly latest = new Map<string, number>();
	private seq = 0;

	enqueue<T>(key: string, send: () => Promise<T>): Promise<SaveOutcome<T>> {
		const id = ++this.seq;
		this.latest.set(key, id);
		const isLatest = () => this.latest.get(key) === id;
		// tails には失敗しない outcome だけを積むので、前の保存が失敗しても次は送られる。
		const outcome = (this.tails.get(key) ?? Promise.resolve()).then(send).then(
			(value): SaveOutcome<T> => ({ ok: true, value, latest: isLatest() }),
			(error: unknown): SaveOutcome<T> => ({ ok: false, error, latest: isLatest() }),
		);
		this.tails.set(key, outcome);
		return outcome;
	}
}
